import Divider from '@enlighten/design-system/dist/Divider';
import Grid from '@enlighten/design-system/dist/Grid2';
import Typography from '@enlighten/design-system/dist/Typography';
import Link from 'next/link';

import Logo from '@/assets/images/logo.svg';
import BlogIcon from '@/assets/images/sns/blog.svg';
import FacebookIcon from '@/assets/images/sns/facebook.svg';
import KakaoChannelIcon from '@/assets/images/sns/kakao.svg';
import YoutubeIcon from '@/assets/images/sns/youtube.svg';
import variables from '@/styles/variables.module.scss';

export default function Info() {
	return (
		<Grid
			container
			direction={{ xs: 'column', md: 'row' }}
			justifyContent="space-between"
			gap={{ xs: '35px', md: 0 }}
			maxWidth={1440}
			padding={{ xs: '34px 25px 55px', md: '62px 24px 61px' }}
			sx={{
				'> .MuiGrid-root:nth-of-type(2)': {
					width: '100%',
				},
			}}
		>
			<Grid
				flex={2}
				sx={{
					'svg *': {
						fill: variables.grey900,
					},
				}}
			>
				<Logo width={170} height={28} viewBox="0 0 146 24" />
				<Grid display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={{ xs: 0, md: '10px' }} marginTop="20px">
					<Typography lineHeight={1.5} color="grey.700">
						엔라이튼(주)
					</Typography>
					<Typography lineHeight={1.5} color="grey.700">
						서울특별시 송파구 올림픽로 289, 잠실시그마타워 4층
					</Typography>
					<Typography lineHeight={1.5} color="grey.700">
						대표이사 : 이영호
					</Typography>
				</Grid>
				<Grid
					container
					direction={{ xs: 'column', md: 'row' }}
					gap={{ xs: 0, md: '10px' }}
					sx={{
						a: {
							textDecoration: `underline ${variables.grey700}`,
						},
					}}
				>
					<Typography lineHeight={1.5} color="grey.700">
						통신판매업신고번호 : 2024-서울송파-0192호
					</Typography>
					<Typography lineHeight={1.5} color="grey.700">
						사업자등록번호 : 884-88-00541
					</Typography>
					<Link href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8848800541" target="_blank">
						<Typography lineHeight={1.5} color="grey.700">
							사업자정보확인
						</Typography>
					</Link>
				</Grid>
				<Typography color="grey.700" margin="6px 0 11px">
					Copyright © ENlighten Co., Ltd. All rights reserved.
				</Typography>
				<Grid
					sx={{
						display: 'flex',
						flexDirection: { xs: 'column', md: 'row' },
						gap: 1,
						'> a': {
							textDecoration: 'none',
						},
						'.MuiDivider-root': {
							display: { xs: 'none', md: 'inline-flex' },
							alignSelf: 'center',
							height: 14,
							marginX: 1,
						},
					}}
				>
					<Link href="/notice?page=1">
						<Typography color="grey.700">공지사항</Typography>
					</Link>
					<Divider orientation="vertical" flexItem />
					<Link href="/terms/1">
						<Typography color="grey.700">서비스이용약관</Typography>
					</Link>
					<Divider orientation="vertical" flexItem />
					<Link href="https://privacy.enlighten.kr/b950f03f-3434-4c34-8a67-13657d724408" target="_blank">
						<Typography>개인정보처리방침</Typography>
					</Link>
					<Divider orientation="vertical" flexItem />
					<Link href="/terms/6">
						<Typography>안전보건경영방침</Typography>
					</Link>
				</Grid>
			</Grid>
			<Grid
				flex={1}
				marginRight={`${25 / 3}%`}
				sx={{
					'a[href="tel:02-6931-0901"] .MuiTypography-root': {
						fontSize: { xs: 28, md: 32 },
					},
				}}
			>
				<Typography fontWeight={700} fontSize={16}>
					고객센터
				</Typography>
				<Link href="tel:02-6931-0901">
					<Typography fontWeight={700} letterSpacing="-0.03em">
						02-6931-0901
					</Typography>
				</Link>
				<Typography marginBottom="18px">평일 09:00 ~ 17:00 (주말/공휴일 제외)</Typography>
				<Grid container gap={3}>
					<Link href="https://blog.naver.com/solarconnect" target="_blank">
						<BlogIcon />
					</Link>
					<Link href="https://www.youtube.com/channel/UCIfan7LaNaOvrYcGgr3kn1A" target="_blank">
						<YoutubeIcon />
					</Link>
					<Link href="http://pf.kakao.com/_FcxnBxl" target="_blank">
						<KakaoChannelIcon />
					</Link>
					<Link href="https://www.facebook.com/enlighten.kr" target="_blank">
						<FacebookIcon />
					</Link>
				</Grid>
			</Grid>
		</Grid>
	);
}
